import { Currencies } from '@orbital/games-frontend-library'
import floorFigure from './floorFigure'

const getBetInfo = (
  obj: any,
  precision: number,
  currency: string,
  title: string,
) => {
  const { bet, mult, win } = obj

  const BET_INFO = []
  const BET = {
    title: 'BET',
    content: bet && floorFigure(bet, precision) + ' ' + currency,
  }
  const PAYOUT = {
    title: 'PAYOUT',
    content: win !== '0' ? (mult === 0 ? '0 to 1' : mult + ' to 1') : '0',
  }
  const WIN = {
    title: 'WIN',
    content:
      win === 0
        ? '0.00 ' + currency
        : floorFigure(win, precision) + ' ' + currency,
  }

  BET_INFO.push(BET)
  title !== 'RAISE' && BET_INFO.push(PAYOUT)
  BET_INFO.push(WIN)

  return { BET_INFO }
}

export default getBetInfo
